export default __webpack_public_path__ + "static/media/locked.a044025d.png";